import { Autocomplete, Box,Button,  Container,  FormControl,  InputLabel,  MenuItem,  Select,  Skeleton,  Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography,ListSubheader,Alert,CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import PrintIcon from '@mui/icons-material/Print';
import {  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

function AnalyseVendeur() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));   

    const userData = useSelector(state => state.userData);
    const [Chargement, setChargement] = useState(false);
    const [listSecteur, setListSecteur] = useState([]);
    const [ListVendeur, setListVendeur] = useState([]);
    const [valVendeurs, setvalVendeurs] = useState('');
    const [ListPreVendeur, setListPreVendeur] = useState([]);
    const [valSecteur, setvalSecteur] = useState(null);
    const [ListeVentes, setListeVentes] = useState([]);
    const [projection, setProjection] = useState(null);
    const [objectifsStats, setObjectifsStats] = useState([]);
    const [chargementObjectifs, setChargementObjectifs] = useState(false);
    const [erreurObjectifs, setErreurObjectifs] = useState('');
    const [chargementProjection, setChargementProjection] = useState(false);
    const [gpsStats, setGpsStats] = useState(null);
const [chargementGps, setChargementGps] = useState(false);

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const todayDate = `${year}-${month}`;

    const [selectedDate, setSelectedDate] = useState(todayDate);
    const [selectedDate2, setSelectedDate2] = useState(todayDate);
    
    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
      };
      const handleDateChange2 = (event) => {
        setSelectedDate2(event.target.value);
      };

    const id = userData.id;
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;

    // Le select mélange vendeurs et prévendeurs : seuls les prévendeurs
    // doivent déclencher le suivi des objectifs.
    const estPrevendeurSelectionne = ListPreVendeur.some(
        (item) => String(item.id) === String(valVendeurs)
    );

    const formatDH = (value) =>
        `${Number(value ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} DH`;

    const formatPourcentage = (value) =>
        `${Number(value ?? 0).toLocaleString('fr-FR', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        })} %`;

    const formatMoisObjectif = (annee, mois) =>
        new Intl.DateTimeFormat('fr-FR', {
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC'
        }).format(new Date(Date.UTC(annee, mois - 1, 1)));


    const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
      };
    
      const handleSecteurChange = (event, newValue) => {
        if (newValue) {
            setvalSecteur(newValue.id);
        } else {
            setvalSecteur(null);
        }
      };


      

        const getPercentage = (value, total) => {
    if (!total || total <= 0) {
      return 0;
    }

    return ((value / total) * 100).toFixed(1);
  };

      function ShowVentes() {
        if(ListeVentes.length > 0){
          return ListeVentes.map(Item => {
            return(
              <StyledTableRow key={Item._id}>
              <StyledTableCell component="th" scope="row">
              {Item.date}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Item.total_ventes.toFixed(2)} Dhs
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Item.count}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
              {Item.visites_uniques}
              </StyledTableCell>
              <StyledTableCell>{Item.taux_retour} %</StyledTableCell>
              <StyledTableCell>
              {Item.taux_retour_chiffres} %
               </StyledTableCell>
            </StyledTableRow>
            )
  
          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={6} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

    const getSecteurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}secteurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }

        );
        const formattedSecteur = [
          { label: "Tout", id: 0 },
          ...response.data.map(item => ({
            label: `${item.designation}`,
            id: item._id
          }))
        ];
        setListSecteur(formattedSecteur)
        }
     catch (error) {
      // navigate('/');    
    }
    }

    const debutMois= (date) => {
        const firstDayOfMonth = new Date(`${date}-01T00:00:00Z`).toISOString();
        return firstDayOfMonth
      }
  
      const finMois= (date) => {
        const endOfMonth = new Date(new Date(`${date}-01T00:00:00Z`).getFullYear(), new Date(`${date}-01T00:00:00Z`).getMonth() + 1, 0);
        endOfMonth.setHours(23, 59, 0, 0);
        const endOfMonthISO = endOfMonth.toISOString();
        return endOfMonthISO
      }

    const getVentes=async () => {
        setChargement(true);
        const debut = debutMois(selectedDate)
        const fin = finMois(selectedDate2)
        try {
        const response = await axios.post(`${apiUrl}statistiques/analysevendeur/ventes/${id}/${apitoken}/${valVendeurs}/${valSecteur}/${debut}/${fin}`,
          {
            timeout: 20000,
          }
  
        );
        setListeVentes(response.data);
        }
     catch (error) {
      // navigate('/');    
    }
    setChargement(false);
    }


    function exportVentesVendeurCSV(data, filename = 'ventes_vendeur.csv') {
  if (!Array.isArray(data) || data.length === 0) {
    alert('Aucune donnée à exporter');
    return;
  }

  const headers = ['Date', "Chiffre d'affaire", 'Nombre de facture', 'Nombre de clients uniques'];
  const SEP = ';';          // Lisible par Excel FR
  const BOM = '\uFEFF';     // Préserve les accents

  const rows = data.map((r) => [
    r.date ?? '',
    (typeof r.total_ventes === 'number'
      ? r.total_ventes.toFixed(2)
      : r.total_ventes ?? ''
    ).toString().replace('.', ','), // virgule décimale
    r.count ?? '',
    r.visites_uniques ?? ''
  ]);

  const csv = BOM + [headers.join(SEP), ...rows.map(row => row.join(SEP))].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

    const getVendeurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListVendeur(response.data);
        }
     catch (error) {
    //   navigate('/');    
    }
    }

            const getPreVendeurs=async () => {
            try {
            const response = await axios.post(`${apiUrl}prevendeurs/${id}/${apitoken}`,
              {
                timeout: 20000,
              }
            );
    
                  const formattedpreVendeur = 
    
            response.data.map(item => ({
              label: `${item.nom}`,
              id: item._id
            }))
          ;
    
            setListPreVendeur(formattedpreVendeur);
            }
         catch (error) {
        //   navigate('/');    
        }
        }


        const getMoisActuel = () => {
  return new Intl.DateTimeFormat("fr-FR", {
    month: "long",
    year: "numeric",
  }).format(new Date());
};


const getGpsStats = async () => {

  setChargementGps(true);

  const debut = debutMois(selectedDate);
  const fin = finMois(selectedDate2);

  try {

    const response = await axios.post(
      `${apiUrl}statistiques/analysevendeur/gps/${id}/${apitoken}/${valVendeurs}/${valSecteur}/${debut}/${fin}`,
      {},
      {
        timeout: 20000,
      }
    );

    setGpsStats(response.data);

    console.log("GPS STATS :", response.data);

  } catch (error) {

    console.error(
      "Erreur statistiques GPS :",
      error
    );

    setGpsStats(null);

  } finally {

    setChargementGps(false);

  }
};

const getProjection = async () => {
  setChargementProjection(true);

  try {
    const response = await axios.post(
      `${apiUrl}statistiques/analysevendeur/projection/${id}/${apitoken}/${valVendeurs}/${valSecteur}`,
      {},
      {
        timeout: 20000,
      }
    );

    setProjection(response.data);

    console.log("PROJECTION :", response.data);
  } catch (error) {
    console.error("Erreur projection :", error);
    setProjection(null);
  } finally {
    setChargementProjection(false);
  }
};

    useEffect(() =>{
        getSecteurs();
        getVendeurs();
        getPreVendeurs();
        },[]);
    
    
        useEffect(() =>{
            getVentes()
            getGpsStats();
            },[valVendeurs,valSecteur,selectedDate,selectedDate2]);

        useEffect(() => {
        getProjection();
      }, [valVendeurs, valSecteur]);

    // Suivi des objectifs : dépend du prévendeur et de la plage de mois,
    // mais volontairement PAS du secteur.
    useEffect(() => {
        let annule = false;

        if (!estPrevendeurSelectionne || !id || !apitoken) {
            setObjectifsStats([]);
            setErreurObjectifs('');
            setChargementObjectifs(false);
            return;
        }

        if (selectedDate > selectedDate2) {
            setObjectifsStats([]);
            setErreurObjectifs('La date de début doit précéder la date de fin.');
            setChargementObjectifs(false);
            return;
        }

        const chargerObjectifs = async () => {
            setChargementObjectifs(true);
            setErreurObjectifs('');
            setObjectifsStats([]);

            try {
                const debut = debutMois(selectedDate);
                const fin = finMois(selectedDate2);
                const response = await axios.post(
                    `${apiUrl}statistiques/analysevendeur/objectifs/${id}/${apitoken}/${valVendeurs}/${debut}/${fin}`,
                    {},
                    { timeout: 20000 }
                );

                if (annule) return;
                if (response.data?.status !== 'ok' || !Array.isArray(response.data.resultats)) {
                    throw new Error('Réponse des objectifs invalide');
                }
                setObjectifsStats(response.data.resultats);
            } catch (error) {
                if (annule) return;
                console.error('Erreur suivi des objectifs :', error);
                setErreurObjectifs('Impossible de charger le suivi des objectifs.');
            } finally {
                if (!annule) setChargementObjectifs(false);
            }
        };

        chargerObjectifs();
        return () => { annule = true; };
    }, [valVendeurs, estPrevendeurSelectionne, selectedDate, selectedDate2, id, apitoken, apiUrl]);


  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>

<Typography mt={5} variant="h4" align='center' color="primary">
        Performance Équipe
        </Typography>

        <Box display="flex" width="100%" mt={5}>

        <Box mt={1}>
        <FormControl  sx={{ minWidth: 160 }}>
          <InputLabel id="demo-simple-select-label">Vendeurs/Prévendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs/prévendeurs"
          onChange={handleVendeurChange}
        >
          <ListSubheader>VENDEURS</ListSubheader>
          {ListVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
        <ListSubheader>PRÉVENDEURS</ListSubheader>
            {ListPreVendeur.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          </FormControl>
        </Box>

        <Box mt={1} ml={2} width={200}>
            <Autocomplete
      disablePortal
      options={listSecteur}
      onChange={handleSecteurChange}
     fullWidth
      renderInput={(params) => <TextField {...params} label="Secteurs" />}
    />
            </Box>

            <Box  ml={2} width={200}>
          <TextField
            autoFocus
            margin="dense"
            id="date1"
            name="date"
            label="Depuis"
            type="month"
            fullWidth
            variant="outlined"
            value={selectedDate}
            onChange={handleDateChange}
          />
          </Box>

          <Box  ml={2} width={200}>
          <TextField
            autoFocus
            margin="dense"
            id="date1"
            name="date"
            label="Au"
            type="month"
            fullWidth
            variant="outlined"
            value={selectedDate2}
            onChange={handleDateChange2}
          />

          </Box>

          <Box display="flex" justifyContent="flex-end" ml={4}>
        <Button variant="contained" size='large' color="success" startIcon={<PrintIcon/>} onClick={() => exportVentesVendeurCSV(ListeVentes)} >
    Exporter
  </Button>   
    </Box>

        </Box>

        <Box mt={5} width='50%' sx={{ float: 'left' }}>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
<ResponsiveContainer width="100%" height={400}>
<AreaChart data={ListeVentes}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        {/* Première zone pour 'total_ventes' */}
        <Area type="monotone" dataKey="total_ventes" stroke="#8884d8" fill="#8884d8" name="Total Ventes" />
      </AreaChart>
    </ResponsiveContainer>
}

    </Box>

    <Box mt={5} width='50%' sx={{ float: 'left' }}>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
<ResponsiveContainer width="100%" height={400}>
<AreaChart data={ListeVentes}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        {/* Deuxième zone pour 'count', renommée en "Nombre de Visites" */}
        <Area type="monotone" dataKey="count" stroke="#82ca9d" fill="#82ca9d" name="Nombre de Visites" />
      </AreaChart>
    </ResponsiveContainer>
}

    </Box>
    <Box sx={{ clear: 'both' }} />

    {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :

        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
      <Table  sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell>Chiffre d'affaire</StyledTableCell>
            <StyledTableCell>Nombre de facture</StyledTableCell>
            <StyledTableCell>Nombre de clients uniques</StyledTableCell>
            <StyledTableCell>Taux de retour(Factures)</StyledTableCell>
            <StyledTableCell>Taux de retour (Chiffres)</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowVentes/>
        </TableBody>
      </Table>
    </TableContainer>
}   

<Box mt={5}>

  <Typography
    variant="h5"
    fontWeight="bold"
    mb={1}
  >
    Suivi terrain GPS
  </Typography>

  <Typography
    variant="body2"
    color="text.secondary"
    mb={3}
  >
    Qualité des positions GPS et présence chez les clients
  </Typography>


  {chargementGps ? (

    <Skeleton
      variant="rounded"
      height={260}
    />

  ) : gpsStats?.status === "ok" &&
      gpsStats?.total_ventes > 0 ? (

    <Box
      display="grid"
      gridTemplateColumns={{
        xs: "1fr",
        md: "1fr 1fr"
      }}
      gap={3}
    >

      {/* ========================================= */}
      {/* QUALITÉ GPS                               */}
      {/* ========================================= */}

      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2
        }}
      >

        <Typography
          variant="h6"
          fontWeight="bold"
        >
          Qualité GPS
        </Typography>


        <Box
          display="flex"
          alignItems="baseline"
          mt={2}
          mb={1}
        >

          <Typography
            variant="h3"
            color="primary"
            fontWeight="bold"
          >
            {gpsStats.gps.indice}
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            ml={1}
          >
            / 100
          </Typography>

        </Box>


        <Typography
          variant="body2"
          color="text.secondary"
          mb={3}
        >
          Indice global de qualité GPS
        </Typography>


<Box
  display="grid"
  gridTemplateColumns="1fr auto"
  gap={1}
>
  <Typography>
    Excellent
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.gps.excellent}
    {" ("}
    {getPercentage(
      gpsStats.gps.excellent,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Bon
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.gps.bon}
    {" ("}
    {getPercentage(
      gpsStats.gps.bon,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Faible
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.gps.faible}
    {" ("}
    {getPercentage(
      gpsStats.gps.faible,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Très faible
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.gps.tres_faible}
    {" ("}
    {getPercentage(
      gpsStats.gps.tres_faible,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Sans GPS
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.gps.sans_gps}
    {" ("}
    {getPercentage(
      gpsStats.gps.sans_gps,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>
</Box>


        <Box
          mt={3}
          pt={2}
          sx={{
            borderTop: "1px solid",
            borderColor: "divider"
          }}
        >

          <Typography
            variant="body2"
            color="text.secondary"
          >
            Précision médiane
          </Typography>

          <Typography
            variant="h6"
            fontWeight="bold"
          >
            {gpsStats.gps.accuracy_mediane != null
              ? `${gpsStats.gps.accuracy_mediane} m`
              : "—"}
          </Typography>

        </Box>

      </Paper>


      {/* ========================================= */}
      {/* PRÉSENCE CLIENT                           */}
      {/* ========================================= */}

      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2
        }}
      >

        <Typography
          variant="h6"
          fontWeight="bold"
        >
          Présence chez les clients
        </Typography>


        <Box
          display="flex"
          alignItems="baseline"
          mt={2}
          mb={1}
        >

          <Typography
            variant="h3"
            color="success.main"
            fontWeight="bold"
          >
            {gpsStats.presence.taux != null
              ? `${gpsStats.presence.taux} %`
              : "—"}
          </Typography>

        </Box>


        <Typography
          variant="body2"
          color="text.secondary"
          mb={3}
        >
          Sur les ventes actuellement vérifiables
        </Typography>


<Box
  display="grid"
  gridTemplateColumns="1fr auto"
  gap={1}
>
  <Typography>
    Chez le client
  </Typography>

  <Typography
    fontWeight="bold"
    color="success.main"
  >
    {gpsStats.presence.verified}
    {" ("}
    {getPercentage(
      gpsStats.presence.verified,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Hors client
  </Typography>

  <Typography
    fontWeight="bold"
    color="error.main"
  >
    {gpsStats.presence.outside}
    {" ("}
    {getPercentage(
      gpsStats.presence.outside,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    En apprentissage
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.presence.learning}
    {" ("}
    {getPercentage(
      gpsStats.presence.learning,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    GPS faible
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.presence.gps_faible}
    {" ("}
    {getPercentage(
      gpsStats.presence.gps_faible,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>


  <Typography>
    Sans GPS
  </Typography>

  <Typography fontWeight="bold">
    {gpsStats.presence.no_gps}
    {" ("}
    {getPercentage(
      gpsStats.presence.no_gps,
      gpsStats.total_ventes
    )}
    {" %)"}
  </Typography>
</Box>


        <Box
          mt={3}
          pt={2}
          sx={{
            borderTop: "1px solid",
            borderColor: "divider"
          }}
        >

          <Typography
            variant="body2"
            color="text.secondary"
          >
            Ventes vérifiables
          </Typography>

<Typography
  variant="h6"
  fontWeight="bold"
>
  {gpsStats.presence.verifiables}
  {" / "}
  {gpsStats.total_ventes}
  {" ("}
  {getPercentage(
    gpsStats.presence.verifiables,
    gpsStats.total_ventes
  )}
  {" %)"}
</Typography>

        </Box>

      </Paper>

    </Box>

  ) : (

    <Alert severity="info">
      Aucune donnée GPS disponible pour cette période.
    </Alert>

  )}

</Box>

<div className="mt-8">

  <div className="flex items-center justify-between mb-3">

    <div>
      <h3 className="font-bold text-lg">
        Projection du mois
      </h3>

      <p className="text-sm text-gray-500">
        Estimation basée sur le rythme de vente des 3 derniers mois
      </p>
    </div>

  </div>


  {chargementProjection ? (

    <div className="flex justify-center p-6">
      <CircularProgress size={25} />
    </div>

  ) : projection?.status === "ok" ? (

    <TableContainer component={Paper}>

      <Table aria-label="customized table">

        <TableHead>
          <TableRow>

            <TableCell>
              Mois
            </TableCell>

            <TableCell align="right">
              CA réalisé
            </TableCell>

            <TableCell align="right">
              Projection fin de mois
            </TableCell>

            <TableCell align="right">
              Rythme
            </TableCell>

            <TableCell align="right">
              Jours restants
            </TableCell>

          </TableRow>
        </TableHead>


        <TableBody>

          <TableRow>

            <TableCell
              sx={{
                textTransform: "capitalize"
              }}
            >
              {getMoisActuel()}
            </TableCell>


            <TableCell align="right">
              {projection.ca_actuel?.toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} DH
            </TableCell>


            <TableCell
              align="right"
              sx={{
                fontWeight: "bold",
                fontSize: "1rem"
              }}
            >
              ≈ {projection.projection?.toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} DH
            </TableCell>


            <TableCell align="right">

              {projection.evolution_rythme > 0 ? "+" : ""}

              {projection.evolution_rythme?.toLocaleString("fr-FR", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })} %

            </TableCell>


            <TableCell align="right">
              {projection.jours_restants}
            </TableCell>

          </TableRow>

        </TableBody>

      </Table>

    </TableContainer>

  ) : projection?.status === "historique_insuffisant" ? (

    <Alert severity="info">
      Pas assez de données historiques pour calculer une projection fiable.
    </Alert>

  ) : (

    <Alert severity="info">
      Aucune projection disponible.
    </Alert>

  )}

</div>


    {/* Suivi des objectifs par marque : visible uniquement pour un prévendeur */}
    {estPrevendeurSelectionne && (
      <Box mt={5} mb={5}>
        <Typography variant="h5" fontWeight="bold" mb={1}>
          Suivi des objectifs commerciaux
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Objectifs par marque sur la période sélectionnée. Le CA est TTC (TVA 20 %).
          La projection n'est disponible que pour le mois en cours.
        </Typography>

        {chargementObjectifs ? (
          <Skeleton variant="rounded" height={210} />
        ) : erreurObjectifs ? (
          <Alert severity="error">{erreurObjectifs}</Alert>
        ) : objectifsStats.length === 0 ? (
          <Alert severity="info">Aucun objectif disponible pour ce prévendeur sur la période sélectionnée.</Alert>
        ) : (
          <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 850 }}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Mois</StyledTableCell>
                  <StyledTableCell>Marque</StyledTableCell>
                  <StyledTableCell align="right">Objectif CA</StyledTableCell>
                  <StyledTableCell align="right">CA réalisé</StyledTableCell>
                  <StyledTableCell align="right">Atteinte</StyledTableCell>
                  <StyledTableCell align="right">Projection fin de mois</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {objectifsStats.map((item, index) => {
                  const estMoisCourant =
                    item.annee === new Date().getUTCFullYear() &&
                    item.mois === new Date().getUTCMonth() + 1;
                  const taux = Number(item.taux_atteinte ?? 0);

                  return (
                    <StyledTableRow key={`${item.annee}-${item.mois}-${item.marque?.id ?? index}`}>
                      <StyledTableCell sx={{ textTransform: 'capitalize' }}>
                        {formatMoisObjectif(item.annee, item.mois)}
                      </StyledTableCell>
                      <StyledTableCell>{item.marque?.designation ?? '—'}</StyledTableCell>
                      <StyledTableCell align="right">{formatDH(item.objectif_ca)}</StyledTableCell>
                      <StyledTableCell align="right">{formatDH(item.ca_realise)}</StyledTableCell>
                      <StyledTableCell
                        align="right"
                        sx={{ fontWeight: 'bold', color: taux >= 100 ? 'success.main' : 'text.primary' }}
                      >
                        {formatPourcentage(taux)}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {!estMoisCourant ? '—' : item.projection != null && Number(item.objectif_ca) > 0
                          ? (
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
                              <span>{formatDH(item.projection)}</span>
                              <Box
                                component="span"
                                sx={{
                                  fontWeight: 'bold',
                                  color: Number(item.projection) >= Number(item.objectif_ca)
                                    ? 'success.main'
                                    : 'error.main'
                                }}
                              >
                                ({formatPourcentage(Number(item.projection) / Number(item.objectif_ca) * 100)})
                              </Box>
                            </Box>
                          )
                          : item.projection_status === 'historique_insuffisant'
                            ? 'Historique insuffisant'
                            : '—'}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    )}

    </Container>
  )
}

export default AnalyseVendeur